export default __webpack_public_path__ + "static/certificado-taller-de-modificacion-2c9294fa97f82b57a8aa50b3a464cc9f.pdf";